import { createContext, useContext } from 'react';
import { K, setTheme } from '../constants';
import { usePersist } from '../hooks/usePersist';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = usePersist('hydro_theme', 'dark');

  // Keep the mutable K object in sync with current theme
  setTheme(theme);

  const toggleTheme = () => setThemeState((t) => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, K }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider');
  return ctx;
}
